import { render, staticRenderFns } from "./testappio.vue?vue&type=template&id=10f5b6de"
import script from "./testappio.vue?vue&type=script&lang=js"
export * from "./testappio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports